import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const shakeElements = document.querySelectorAll('[data-animate-shake-x]')

shakeElements.forEach(shakeElement => {
  ScrollTrigger.create({
    trigger: shakeElement,
    start: 'top center-=20%',
    end: 'bottom center-=20%',
    once: true,
    // markers: true,
    onEnter: () => {
      gsap.to(shakeElement, { x: -25, duration: .75 })
      gsap.to(shakeElement, { x: 0, duration: .75, delay: .76 })
    }
  })
})

